import isArray from 'lodash/isArray'

import { Feature } from 'types/Feature'

const findFeatureFlag = (features: Feature[] = [], feature: string): Feature | undefined => {
  if (isArray(features)) {
    return features?.find((item) => item.feature === feature)
  }
}

export default findFeatureFlag
